import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link
      to={`/product/${product.id}`}
      className="group block"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="relative overflow-hidden bg-gray-50 aspect-square mb-3 rounded-sm">
        <img
          src={product.image}
          alt={product.name}
          className={`w-full h-full object-cover transition-transform duration-500 ${
            isHovered ? 'scale-110' : 'scale-100'
          }`}
        />
        {product.sold_out && (
          <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
            <span className="text-white text-sm font-medium">SOLD OUT</span>
          </div>
        )}
      </div>
      <h3 className="text-sm font-normal text-gray-800 mb-1 group-hover:text-gray-600 transition-colors">
        {product.name}
      </h3>
      {product.specs && (
        <p className="text-xs text-gray-500 mb-1">{product.specs}</p>
      )}
      <p className="text-sm font-medium text-gray-900">
        {product.sold_out ? (
          <span className="text-red-600">SOLD OUT</span>
        ) : (
          `from $${product.price.toLocaleString()}.00`
        )}
      </p>
    </Link>
  );
};

export default ProductCard;